module.exports = __webpack_public_path__ + "img/HSV.acfbabdc.png";